<template>
  <div class="hend_box">
     <Row>
        <Col span="22" offset="2">
            <img src="../assets/logo.png" alt="">
        </Col>
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {

  },
  components: {

  }
}
</script>

<style scoped>
.hend_box{
    height: 100px;
}

</style>



// WEBPACK FOOTER //
// src/commonality/hender.vue